/**
 * @fileoverview gRPC-Web generated client stub for reportpb
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_type_date_pb = require('../../google/type/date_pb.js')

var proto_utilspb_pagination_pb = require('../../proto/utilspb/pagination_pb.js')
const proto = {};
proto.reportpb = require('./exercisedeclaration_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.reportpb.ExerciseDeclarationServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.reportpb.ExerciseDeclarationServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reportpb.ListExerciseDeclarationRequest,
 *   !proto.reportpb.ListExerciseDeclarationResponse>}
 */
const methodDescriptor_ExerciseDeclarationService_ListExerciseDeclaration = new grpc.web.MethodDescriptor(
  '/reportpb.ExerciseDeclarationService/ListExerciseDeclaration',
  grpc.web.MethodType.UNARY,
  proto.reportpb.ListExerciseDeclarationRequest,
  proto.reportpb.ListExerciseDeclarationResponse,
  /**
   * @param {!proto.reportpb.ListExerciseDeclarationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.ListExerciseDeclarationResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.reportpb.ListExerciseDeclarationRequest,
 *   !proto.reportpb.ListExerciseDeclarationResponse>}
 */
const methodInfo_ExerciseDeclarationService_ListExerciseDeclaration = new grpc.web.AbstractClientBase.MethodInfo(
  proto.reportpb.ListExerciseDeclarationResponse,
  /**
   * @param {!proto.reportpb.ListExerciseDeclarationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.ListExerciseDeclarationResponse.deserializeBinary
);


/**
 * @param {!proto.reportpb.ListExerciseDeclarationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.reportpb.ListExerciseDeclarationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reportpb.ListExerciseDeclarationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reportpb.ExerciseDeclarationServiceClient.prototype.listExerciseDeclaration =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reportpb.ExerciseDeclarationService/ListExerciseDeclaration',
      request,
      metadata || {},
      methodDescriptor_ExerciseDeclarationService_ListExerciseDeclaration,
      callback);
};


/**
 * @param {!proto.reportpb.ListExerciseDeclarationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reportpb.ListExerciseDeclarationResponse>}
 *     Promise that resolves to the response
 */
proto.reportpb.ExerciseDeclarationServicePromiseClient.prototype.listExerciseDeclaration =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reportpb.ExerciseDeclarationService/ListExerciseDeclaration',
      request,
      metadata || {},
      methodDescriptor_ExerciseDeclarationService_ListExerciseDeclaration);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reportpb.CreateExerciseDeclarationRequest,
 *   !proto.reportpb.CreateExerciseDeclarationResponse>}
 */
const methodDescriptor_ExerciseDeclarationService_CreateExerciseDeclaration = new grpc.web.MethodDescriptor(
  '/reportpb.ExerciseDeclarationService/CreateExerciseDeclaration',
  grpc.web.MethodType.UNARY,
  proto.reportpb.CreateExerciseDeclarationRequest,
  proto.reportpb.CreateExerciseDeclarationResponse,
  /**
   * @param {!proto.reportpb.CreateExerciseDeclarationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.CreateExerciseDeclarationResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.reportpb.CreateExerciseDeclarationRequest,
 *   !proto.reportpb.CreateExerciseDeclarationResponse>}
 */
const methodInfo_ExerciseDeclarationService_CreateExerciseDeclaration = new grpc.web.AbstractClientBase.MethodInfo(
  proto.reportpb.CreateExerciseDeclarationResponse,
  /**
   * @param {!proto.reportpb.CreateExerciseDeclarationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.CreateExerciseDeclarationResponse.deserializeBinary
);


/**
 * @param {!proto.reportpb.CreateExerciseDeclarationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.reportpb.CreateExerciseDeclarationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reportpb.CreateExerciseDeclarationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reportpb.ExerciseDeclarationServiceClient.prototype.createExerciseDeclaration =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reportpb.ExerciseDeclarationService/CreateExerciseDeclaration',
      request,
      metadata || {},
      methodDescriptor_ExerciseDeclarationService_CreateExerciseDeclaration,
      callback);
};


/**
 * @param {!proto.reportpb.CreateExerciseDeclarationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reportpb.CreateExerciseDeclarationResponse>}
 *     Promise that resolves to the response
 */
proto.reportpb.ExerciseDeclarationServicePromiseClient.prototype.createExerciseDeclaration =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reportpb.ExerciseDeclarationService/CreateExerciseDeclaration',
      request,
      metadata || {},
      methodDescriptor_ExerciseDeclarationService_CreateExerciseDeclaration);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reportpb.UpdateExerciseDeclarationRequest,
 *   !proto.reportpb.UpdateExerciseDeclarationResponse>}
 */
const methodDescriptor_ExerciseDeclarationService_UpdateExerciseDeclaration = new grpc.web.MethodDescriptor(
  '/reportpb.ExerciseDeclarationService/UpdateExerciseDeclaration',
  grpc.web.MethodType.UNARY,
  proto.reportpb.UpdateExerciseDeclarationRequest,
  proto.reportpb.UpdateExerciseDeclarationResponse,
  /**
   * @param {!proto.reportpb.UpdateExerciseDeclarationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.UpdateExerciseDeclarationResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.reportpb.UpdateExerciseDeclarationRequest,
 *   !proto.reportpb.UpdateExerciseDeclarationResponse>}
 */
const methodInfo_ExerciseDeclarationService_UpdateExerciseDeclaration = new grpc.web.AbstractClientBase.MethodInfo(
  proto.reportpb.UpdateExerciseDeclarationResponse,
  /**
   * @param {!proto.reportpb.UpdateExerciseDeclarationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.UpdateExerciseDeclarationResponse.deserializeBinary
);


/**
 * @param {!proto.reportpb.UpdateExerciseDeclarationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.reportpb.UpdateExerciseDeclarationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reportpb.UpdateExerciseDeclarationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reportpb.ExerciseDeclarationServiceClient.prototype.updateExerciseDeclaration =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reportpb.ExerciseDeclarationService/UpdateExerciseDeclaration',
      request,
      metadata || {},
      methodDescriptor_ExerciseDeclarationService_UpdateExerciseDeclaration,
      callback);
};


/**
 * @param {!proto.reportpb.UpdateExerciseDeclarationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reportpb.UpdateExerciseDeclarationResponse>}
 *     Promise that resolves to the response
 */
proto.reportpb.ExerciseDeclarationServicePromiseClient.prototype.updateExerciseDeclaration =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reportpb.ExerciseDeclarationService/UpdateExerciseDeclaration',
      request,
      metadata || {},
      methodDescriptor_ExerciseDeclarationService_UpdateExerciseDeclaration);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reportpb.CreateExerciseNoticeRequest,
 *   !proto.reportpb.CreateExerciseNoticeResponse>}
 */
const methodDescriptor_ExerciseDeclarationService_CreateExerciseNotice = new grpc.web.MethodDescriptor(
  '/reportpb.ExerciseDeclarationService/CreateExerciseNotice',
  grpc.web.MethodType.UNARY,
  proto.reportpb.CreateExerciseNoticeRequest,
  proto.reportpb.CreateExerciseNoticeResponse,
  /**
   * @param {!proto.reportpb.CreateExerciseNoticeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.CreateExerciseNoticeResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.reportpb.CreateExerciseNoticeRequest,
 *   !proto.reportpb.CreateExerciseNoticeResponse>}
 */
const methodInfo_ExerciseDeclarationService_CreateExerciseNotice = new grpc.web.AbstractClientBase.MethodInfo(
  proto.reportpb.CreateExerciseNoticeResponse,
  /**
   * @param {!proto.reportpb.CreateExerciseNoticeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.CreateExerciseNoticeResponse.deserializeBinary
);


/**
 * @param {!proto.reportpb.CreateExerciseNoticeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.reportpb.CreateExerciseNoticeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reportpb.CreateExerciseNoticeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reportpb.ExerciseDeclarationServiceClient.prototype.createExerciseNotice =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reportpb.ExerciseDeclarationService/CreateExerciseNotice',
      request,
      metadata || {},
      methodDescriptor_ExerciseDeclarationService_CreateExerciseNotice,
      callback);
};


/**
 * @param {!proto.reportpb.CreateExerciseNoticeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reportpb.CreateExerciseNoticeResponse>}
 *     Promise that resolves to the response
 */
proto.reportpb.ExerciseDeclarationServicePromiseClient.prototype.createExerciseNotice =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reportpb.ExerciseDeclarationService/CreateExerciseNotice',
      request,
      metadata || {},
      methodDescriptor_ExerciseDeclarationService_CreateExerciseNotice);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reportpb.UpdateExerciseNoticeRequest,
 *   !proto.reportpb.UpdateExerciseNoticeResponse>}
 */
const methodDescriptor_ExerciseDeclarationService_UpdateExerciseNotice = new grpc.web.MethodDescriptor(
  '/reportpb.ExerciseDeclarationService/UpdateExerciseNotice',
  grpc.web.MethodType.UNARY,
  proto.reportpb.UpdateExerciseNoticeRequest,
  proto.reportpb.UpdateExerciseNoticeResponse,
  /**
   * @param {!proto.reportpb.UpdateExerciseNoticeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.UpdateExerciseNoticeResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.reportpb.UpdateExerciseNoticeRequest,
 *   !proto.reportpb.UpdateExerciseNoticeResponse>}
 */
const methodInfo_ExerciseDeclarationService_UpdateExerciseNotice = new grpc.web.AbstractClientBase.MethodInfo(
  proto.reportpb.UpdateExerciseNoticeResponse,
  /**
   * @param {!proto.reportpb.UpdateExerciseNoticeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.UpdateExerciseNoticeResponse.deserializeBinary
);


/**
 * @param {!proto.reportpb.UpdateExerciseNoticeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.reportpb.UpdateExerciseNoticeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reportpb.UpdateExerciseNoticeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reportpb.ExerciseDeclarationServiceClient.prototype.updateExerciseNotice =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reportpb.ExerciseDeclarationService/UpdateExerciseNotice',
      request,
      metadata || {},
      methodDescriptor_ExerciseDeclarationService_UpdateExerciseNotice,
      callback);
};


/**
 * @param {!proto.reportpb.UpdateExerciseNoticeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reportpb.UpdateExerciseNoticeResponse>}
 *     Promise that resolves to the response
 */
proto.reportpb.ExerciseDeclarationServicePromiseClient.prototype.updateExerciseNotice =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reportpb.ExerciseDeclarationService/UpdateExerciseNotice',
      request,
      metadata || {},
      methodDescriptor_ExerciseDeclarationService_UpdateExerciseNotice);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reportpb.ReadExerciseDeclarationRequest,
 *   !proto.reportpb.ReadExerciseDeclarationResponse>}
 */
const methodDescriptor_ExerciseDeclarationService_ReadExerciseDeclaration = new grpc.web.MethodDescriptor(
  '/reportpb.ExerciseDeclarationService/ReadExerciseDeclaration',
  grpc.web.MethodType.UNARY,
  proto.reportpb.ReadExerciseDeclarationRequest,
  proto.reportpb.ReadExerciseDeclarationResponse,
  /**
   * @param {!proto.reportpb.ReadExerciseDeclarationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.ReadExerciseDeclarationResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.reportpb.ReadExerciseDeclarationRequest,
 *   !proto.reportpb.ReadExerciseDeclarationResponse>}
 */
const methodInfo_ExerciseDeclarationService_ReadExerciseDeclaration = new grpc.web.AbstractClientBase.MethodInfo(
  proto.reportpb.ReadExerciseDeclarationResponse,
  /**
   * @param {!proto.reportpb.ReadExerciseDeclarationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.ReadExerciseDeclarationResponse.deserializeBinary
);


/**
 * @param {!proto.reportpb.ReadExerciseDeclarationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.reportpb.ReadExerciseDeclarationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reportpb.ReadExerciseDeclarationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reportpb.ExerciseDeclarationServiceClient.prototype.readExerciseDeclaration =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reportpb.ExerciseDeclarationService/ReadExerciseDeclaration',
      request,
      metadata || {},
      methodDescriptor_ExerciseDeclarationService_ReadExerciseDeclaration,
      callback);
};


/**
 * @param {!proto.reportpb.ReadExerciseDeclarationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reportpb.ReadExerciseDeclarationResponse>}
 *     Promise that resolves to the response
 */
proto.reportpb.ExerciseDeclarationServicePromiseClient.prototype.readExerciseDeclaration =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reportpb.ExerciseDeclarationService/ReadExerciseDeclaration',
      request,
      metadata || {},
      methodDescriptor_ExerciseDeclarationService_ReadExerciseDeclaration);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reportpb.ReadExerciseNoticeRequest,
 *   !proto.reportpb.ReadExerciseNoticeResponse>}
 */
const methodDescriptor_ExerciseDeclarationService_ReadExerciseNotice = new grpc.web.MethodDescriptor(
  '/reportpb.ExerciseDeclarationService/ReadExerciseNotice',
  grpc.web.MethodType.UNARY,
  proto.reportpb.ReadExerciseNoticeRequest,
  proto.reportpb.ReadExerciseNoticeResponse,
  /**
   * @param {!proto.reportpb.ReadExerciseNoticeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.ReadExerciseNoticeResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.reportpb.ReadExerciseNoticeRequest,
 *   !proto.reportpb.ReadExerciseNoticeResponse>}
 */
const methodInfo_ExerciseDeclarationService_ReadExerciseNotice = new grpc.web.AbstractClientBase.MethodInfo(
  proto.reportpb.ReadExerciseNoticeResponse,
  /**
   * @param {!proto.reportpb.ReadExerciseNoticeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.ReadExerciseNoticeResponse.deserializeBinary
);


/**
 * @param {!proto.reportpb.ReadExerciseNoticeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.reportpb.ReadExerciseNoticeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reportpb.ReadExerciseNoticeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reportpb.ExerciseDeclarationServiceClient.prototype.readExerciseNotice =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reportpb.ExerciseDeclarationService/ReadExerciseNotice',
      request,
      metadata || {},
      methodDescriptor_ExerciseDeclarationService_ReadExerciseNotice,
      callback);
};


/**
 * @param {!proto.reportpb.ReadExerciseNoticeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reportpb.ReadExerciseNoticeResponse>}
 *     Promise that resolves to the response
 */
proto.reportpb.ExerciseDeclarationServicePromiseClient.prototype.readExerciseNotice =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reportpb.ExerciseDeclarationService/ReadExerciseNotice',
      request,
      metadata || {},
      methodDescriptor_ExerciseDeclarationService_ReadExerciseNotice);
};


module.exports = proto.reportpb;

